<template>
    <breadCrumbs title="Support Ticket" title1="Support Ticket" />
    <div class="container-fluid support-ticket">
        <div class="row">
            <div class="col-sm-12 text-start">
                <div class="card">
                    <div class="card-header pb-0">
                        <h3>Ticket List</h3><span>List of ticket opend by customers</span>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <ticket />
                            <ticket2 />
                        </div>
                        <div class="table-responsive ticket-table">
                            <table class="display dataTable" id="basic-6">
                                <EasyDataTable :headers="Headers" rowsPerPage="10" :items="Item">
                                    <template #item-name="{ name, avator }">
                                        <div class="player-wrapper">
                                            <img class="avator" :src="avator" alt="" />
                                            {{ name }}
                                        </div>
                                    </template>
                                    <template #item-Skill="{ classe, widthe }">
                                        <div class="progress-showcase">
                                            <div class="progress sm-progress-bar">
                                                <div class="progress-bar " :class="classe" role="progressbar"
                                                    :style="{ width: widthe }" aria-valuenow="50" aria-valuemin="0"
                                                    aria-valuemax="100"></div>
                                            </div>
                                        </div>
                                    </template>
                                </EasyDataTable>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import supportTable from "@/mixins/supportTable"
import { mapState } from "vuex";
import ticket from "./ticketPage.vue"
import ticket2 from "./ticket2Page.vue"
export default {
    mixins: [supportTable],
    components: {
        ticket,
        ticket2
    },
    computed: {
        ...mapState({
            supportItems: (state) => state.support.items,
        }),
    },
    mounted() {

    },
    methods: {
        getImageUrl(path) {
            return require("../../assets/images/user/" + path);
        },
    }
}
</script>
<style scoped>
.avator {
    margin-right: 10px;
    display: inline-block;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
    box-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 10%);
}

.player-wrapper {
    padding: 5px;
    display: flex;
    align-items: center;
    justify-items: center;
}
</style>
